import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import SatelliteComparison from '../../../SatelliteComparison/SatelliteComparison';
import satelliteIcon from '../../../satelliteIcon';

const SignsCustomSoftware3 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="signsCustomSoftware" section="comparison">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="signsCustomSoftware:comparison" first />
            </div>
            <SatelliteComparison t={props.t} prefix="signsCustomSoftware:comparison.cards" highlight="custom" />
        </div>
    </ServiceSection>
);

export default SignsCustomSoftware3;
